import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { IconFullscreenExit } from '@prisjakt/ui/icon/fullscreen-exit';

import { AppContext } from 'src/components/app-context';
import { TooltipPlacement } from 'src/components/tooltip-new';
import { toggleFilter } from '../../../sidebar/actions/filter';

import * as S from './styles';

interface FilterToggleProps {
  expanded?: boolean;
  toggleHorizontalFilter: () => void;
}

const FilterToggle: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<FilterToggleProps>>
> = ({ expanded, toggleHorizontalFilter }) => {
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();

  const label = expanded
    ? t('filter', 'button.toggle-filter')
    : t('filter', 'button.toggle-filter-expand');

  return (
    <S.Tooltip placement={TooltipPlacement.RIGHT} title={label}>
      <S.SidebarFilterButton
        onClick={() => {
          toggleHorizontalFilter();
          dispatch(toggleFilter());
        }}
        icon={<IconFullscreenExit size={30} />}
        variant="icon"
        title={label}
        scaleIcon={false}
        size="large"
      />
    </S.Tooltip>
  );
};

export default FilterToggle;
